/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  app.Filters.RangeFilter = app.Model.extend({
    
    defaults: {
      object: false,
      element: false,
      minSelected: 0,
      maxSelected: 0,
      view: null,
      slider_step: 1
    },
    
    initialize: function () {
      var object = this.get('object');
      var slider_step = object.slider_step ? object.slider_step : this.get('slider_step');
      this.set('minSelected', object.values.min.selected);
      this.set('maxSelected', object.values.max.selected);
      this.set('slider_step', slider_step);
      this.view = new app.Filters.RangeFilterView({
        model: this,
        object: object,
        parent: this.get('element')
      });
    },
    
    toQuery: function (obj) {
      if (this.get('object').values.min.value < this.get('minSelected') || this.get('object').values.max.value > this.get('maxSelected')) {
        obj[this.get('object').name] = [this.get('minSelected'), this.get('maxSelected')];
      }
      return obj;
    }
  });
})();

}.call(window));